// Native scroll — no hijacking. The Lenis smooth-scroll layer was removed for
// INP/UX reasons; these helpers abstract *where* to scroll, not the feel.
// Kept as a module so anchor routes and ScrollToTop share one offset policy.

export const NAV_OFFSET = 72

export function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
}

export function scrollToTarget(target, offset = NAV_OFFSET) {
  const el = typeof target === 'string' ? document.querySelector(target) : target
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - offset
  window.scrollTo({ top, behavior: 'smooth' })
}
